import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Users, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Settings = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-6xl">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold" style={{fontFamily: 'Manrope, sans-serif'}}>
            Einstellungen
          </h1>
          <p className="text-muted-foreground mt-2">
            Systemeinstellungen & Benutzerrollen
          </p>
        </div>

        {/* Rollen & Berechtigungen */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Users className="h-5 w-5" />
              Rollen & Berechtigungen
            </CardTitle>
            <CardDescription>
              Übersicht der verfügbaren Benutzerrollen im System
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="border-l-4 border-blue-500 pl-4 py-2 bg-blue-50 dark:bg-blue-950/30 rounded-r">
                <h4 className="font-semibold text-sm text-blue-900 dark:text-blue-100">Administrator</h4>
                <p className="text-xs text-blue-800 dark:text-blue-200 mt-1">
                  Vollzugriff auf alle Funktionen, Einstellungen und Standortverwaltung
                </p>
              </div>

              <div className="border-l-4 border-green-500 pl-4 py-2 bg-green-50 dark:bg-green-950/30 rounded-r">
                <h4 className="font-semibold text-sm text-green-900 dark:text-green-100">Stationsleitung</h4>
                <p className="text-xs text-green-800 dark:text-green-200 mt-1">
                  Verwaltung des zugewiesenen Standorts, Aufgaben- und Mitarbeiterverwaltung
                </p>
              </div>

              <div className="border-l-4 border-gray-500 pl-4 py-2 bg-gray-50 dark:bg-gray-800/30 rounded-r">
                <h4 className="font-semibold text-sm text-gray-900 dark:text-gray-100">Mitarbeiter</h4>
                <p className="text-xs text-gray-800 dark:text-gray-200 mt-1">
                  Bearbeitung von Aufgaben, Temperaturmessungen und Unterweisungen
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Account löschen */}
        <div className="flex justify-start">
          <Button
            variant="ghost"
            onClick={() => navigate('/admin/delete-account')}
            className="text-red-500 hover:text-red-700 hover:bg-red-50 text-sm flex items-center gap-2"
            data-testid="delete-account-btn"
          >
            <Trash2 className="h-4 w-4" />
            Account löschen
          </Button>
        </div>
      </div>
    </DashboardLayout>
  );
};
